import { render, staticRenderFns } from "./ProfileCollection.feeds.vue?vue&type=template&id=0bc8e862&scoped=true&"
import script from "./ProfileCollection.feeds.vue?vue&type=script&lang=js&"
export * from "./ProfileCollection.feeds.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCollection.feeds.vue?vue&type=style&index=0&id=0bc8e862&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8e862",
  null
  
)

export default component.exports